import { lsLoad } from '../tools/Storage';
import StorageEnum from '../enums/Storage.enum';
import { Roles } from '../generated/fresh-guard-api';

export default () => {
  const profile = lsLoad(StorageEnum.UserProfile);

  if (profile?.roles && profile.roles.length > 0) {
    if (profile.roles.includes(Roles.RoleAdmin)) {
      return true;
    }
  }

  return false;
};
